import { useFeatureValue } from '@shared/core/featureFlags';
import { useMemo } from 'react';
import { isPromoValid, isValidSalesPayload } from '@shared/utils/promotions';
import type { ProductInfo, Sale } from '@shared/utils/promotions';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated';

// Re-export for backwards compatibility
export type { Sale } from '@shared/utils/promotions';
export { isValidSalesPayload } from '@shared/utils/promotions';

export const useSalesConfig = (category: StationeryTemplateCategoryEnum, product?: ProductInfo) => {
  const { value, payload } = useFeatureValue('printSaleCodeV2');

  const sales: Sale[] | null = isValidSalesPayload(payload) ? payload : null;

  const currentSale = useMemo(() => {
    // TODO: Add occasion checking once we add further support for occasions.
    // Currently hardcoding occasion as we do not have a standardized way of fetching it.
    // And in the card customzier, it is not even tracked.
    const defaultProduct = { occasion: 'wedding', category };
    return sales?.find(sale => isPromoValid(sale, product ?? defaultProduct));
  }, [category, product, sales]);

  return {
    isEnabled: value !== undefined && currentSale !== undefined,
    sales,
    /**
     * The promotion config for the currently stored promo code.
     */
    currentSale: currentSale,
  };
};
